export default {
  okText: 'ÐÐº',
  dismissText: 'ÐÑÐ¼ÐµÐ½Ð°',
  extra: '',
};
